import { ChevronDown } from 'lucide-react';
import RouteStep from '@/pages/Tools/RouteStep';
import {
  HopCard,
  HopStackColumn,
  HopStackRow,
  ExpandButton,
} from '../../styles';
import type { HopType } from '../../types';

interface HopsDiagramCardProps {
  route: HopType[];
  expanded: boolean;
  isSm: boolean;
  onToggleExpand: () => void;
}

// Displays a diagram of the traceroute hops
export function HopsDiagramCard({
  route,
  expanded,
  isSm,
  onToggleExpand,
}: HopsDiagramCardProps) {
  if (route.length === 0) {
    return null;
  }

  return (
    <HopCard $expanded={expanded}>
      {expanded ? (
        <HopStackColumn>
          <RouteStep expanded={expanded} route={route} />
        </HopStackColumn>
      ) : (
        <HopStackRow>
          <RouteStep expanded={expanded} route={route} />
        </HopStackRow>
      )}
      <ExpandButton $expanded={expanded} onClick={onToggleExpand} $isSm={isSm}>
        <ChevronDown />
      </ExpandButton>
    </HopCard>
  );
}

export default HopsDiagramCard;
